var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSchoolIcon = function SvgSchoolIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.597,
    height: 21.597,
    viewBox: "0 0 21.597 21.597",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2460",
    "data-name": "Group 2460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26107",
    "data-name": "Path 26107",
    d: "M559.705,159.233a.719.719,0,0,1,.479.8c-.012.168,0,.338-.005.506a.617.617,0,0,1-.661.637c-.6,0-1.209,0-1.813,0h-.22c-.006.067-.015.12-.015.174,0,.64.007,1.279-.005,1.919a.323.323,0,0,0,.224.357q3.3,1.485,6.591,2.988a3.054,3.054,0,0,1,.358.178.63.63,0,0,1-.527,1.13c-.171-.057-.335-.136-.532-.217v.285q0,6.02,0,12.04a.719.719,0,0,1-.177.586.711.711,0,0,1-.4.2c-1.159.016-2.318.009-3.506.009v-.254q0-2.161,0-4.323c0-.514-.227-.74-.746-.741q-1.93,0-3.859,0a.626.626,0,0,0-.714.707q0,2.172,0,4.344v.269h-3.347a.652.652,0,0,1-.734-.743q0-4.312,0-8.624V167.7l-.361.16a.643.643,0,1,1-.53-1.158l4.826-2.192c.721-.328,1.442-.657,2.174-.991V161.43c0-.464.017-.929-.005-1.391a.75.75,0,0,1,.469-.805Zm-2.871,13.5a2.66,2.66,0,1,0-2.657-2.669A2.662,2.662,0,0,0,556.834,172.736Z",
    transform: "translate(-546.038 -159.233)",
    fill: "#b5b5c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26108",
    "data-name": "Path 26108",
    d: "M497.548,428.819a.825.825,0,0,1,.859-.461c.638.017,1.277,0,1.934,0v7.37c-.754,0-1.5.01-2.24,0-.283-.005-.436-.22-.552-.455Z",
    transform: "translate(-497.548 -414.139)",
    fill: "#e7e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26109",
    "data-name": "Path 26109",
    d: "M853.4,435.8v-7.361c.067-.006.121-.014.176-.014.632,0,1.265,0,1.9,0a.652.652,0,0,1,.724.732q0,2.961,0,5.923a.637.637,0,0,1-.709.717Z",
    transform: "translate(-834.6 -414.2)",
    fill: "#e7e7eb"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSchoolIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/schoolIcon.ffb49d31.svg";
export { ForwardRef as ReactComponent };